import {ModalRenderer} from "../ModalRenderer";
import {ModalInstance} from "../ModalInstance";
import {ApplicationRef, ComponentFactoryResolver, ComponentRef, ElementRef, Injectable, Injector, TemplateRef} from "@angular/core";
import {ComponentModalCompileContext, ModalCompileContext, TemplateModalCompileContext} from "../ModalCompileContext";
// noinspection TypeScriptPreferShortImport
import {NModalBackdropComponent, NModalLayerComponent} from "../components/public_components";
import {ModalContext} from "../ModalContext";
import {IModalOptions} from "../IModalOptions";

@Injectable({providedIn: "root"})
export class DOMModalRenderer extends ModalRenderer {

  private rootElm: ElementRef;

  constructor(private injector: Injector, private appRef: ApplicationRef) {
    super();
  }

  renderBackdrop(inj?: Injector): ComponentRef<NModalBackdropComponent> {

    const injector = inj || this.injector;

    const resolver = this.injector.get(ComponentFactoryResolver);

    const cmpFactory = resolver.resolveComponentFactory(NModalBackdropComponent);

    const cmpRef = cmpFactory.create(injector);

    const modal = document.body.querySelector("modal-window");
    injector.get(ApplicationRef).attachView(cmpRef.hostView);

    if (modal) {
      document.body.insertBefore(cmpRef.location.nativeElement, modal);
    } else {
      document.body.appendChild(cmpRef.location.nativeElement);
    }

    return cmpRef;
  }

  render<T>(type: Function,
            modalData: any,
            options: IModalOptions = {},
            layerNumber: number): ModalInstance<T> {

    const injector = options.injector || this.injector;

    const modalContext = new ModalContext<any, any>(modalData, options);
    const resolver = options.resolver || injector.get(ComponentFactoryResolver);

    const compileContext = new ComponentModalCompileContext(modalContext, resolver, type, layerNumber);

    const bindings = (options.bindings || []).concat([
      {provide: ModalRenderer, useValue: this},
      {provide: ModalCompileContext, useValue: compileContext},
      {provide: ModalContext, useValue: modalContext}
    ]);

    compileContext.bindings = bindings;

    const childInjector = Injector.create({
      providers: bindings,
      parent: injector
    });

    const cmpFactory = resolver.resolveComponentFactory(NModalLayerComponent);
    const cmpRef = cmpFactory.create(childInjector);
    this.appRef.attachView(cmpRef.hostView);

    document.body.appendChild(cmpRef.location.nativeElement);

    return new ModalInstance<T>(cmpRef, modalContext, options && options.stashed);
  }

  renderTemplate<T>(template: TemplateRef<any>,
                    modalData: any,
                    options: IModalOptions,
                    layerNumber: number): ModalInstance<T> {
    const injector = options.injector || this.injector;

    const modalContext = new ModalContext<any, any>(modalData, options);
    const resolver = options.resolver || injector.get(ComponentFactoryResolver);

    const compileContext = new TemplateModalCompileContext(modalContext, template, layerNumber);

    const bindings = (options.bindings || []).concat([
      {provide: ModalRenderer, useValue: this},
      {provide: ModalCompileContext, useValue: compileContext},
      {provide: ModalContext, useValue: modalContext}
    ]);

    const childInjector = Injector.create({
      providers: bindings,
      parent: injector
    });

    const cmpFactory = resolver.resolveComponentFactory(NModalLayerComponent);
    const cmpRef = cmpFactory.create(childInjector);
    this.appRef.attachView(cmpRef.hostView);

    const rootElement = this.getRootElement();

    rootElement.nativeElement.appendChild(cmpRef.location.nativeElement);

    return new ModalInstance<T>(cmpRef, modalContext, options && options.stashed);
  }

  private getRootElement(): ElementRef {
    if (this.rootElm) {
      return this.rootElm;
    }
    return this.rootElm = this.appRef.components[0].location;
  }


}
